/**
 * Frontend mirror of the backend {@code VsOwnerTypeEnum}.
 *
 * Discriminates whether a vs entity (Visit) belongs to a concrete customer
 * (cr.Customer) or to a pre-sales lead (lm.LmLead).
 *
 * Ordinal-based — values MUST NOT be reordered; the backend persists ordinal integers.
 *
 * Mirrors: {@code com.mvs.backend.vs.enums.VsOwnerTypeEnum}
 * Ordinals (append-only): customer[0], lead[1]
 *
 * @ticket TM-1000001921
 */
export enum VsOwnerTypeEnum {
    customer,
    lead,
}

/** German UI label for each owner type. */
export const VsOwnerTypeLabel: Record<VsOwnerTypeEnum, string> = {
    [VsOwnerTypeEnum.customer]: 'Kunde',
    [VsOwnerTypeEnum.lead]:     'Lead',
};

/**
 * Returns the German UI label for the given owner type.
 * Returns an empty string for null/undefined so templates can bind safely.
 */
export function getVsOwnerTypeLabel(
    ownerType: VsOwnerTypeEnum | null | undefined
): string {
    if (ownerType === null || ownerType === undefined) {
        return '';
    }
    return VsOwnerTypeLabel[ownerType] ?? VsOwnerTypeEnum[ownerType] ?? '';
}
